import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import styles from 'styles/jss/original/components/shoppings/shoppingCommentTimeline';
import { SHOPPING_COMMENT_TIMELINE } from '@/constants/app';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import ShoppingCommentTimelineItemContainer from '@/containers/shoppings/ShoppingCommentTimelineItemContainer';
import { Comment } from '@/domains/firestore/comment';

dayjs.locale('ja');

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  commentList: Comment[];
  shoppingId: string;
};

const ShoppingCommentTimeline: React.FC<ComponentProps> = ({ commentList, shoppingId }) => {
  const classes = useStyles();

  if (commentList.length === 0) return null;
  return (
    <div className={classes.section}>
      {/* @ts-expect-error */}
      <GridContainer justify='center'>
        {/* @ts-expect-error */}
        <GridItem xs={12} sm={10} md={8}>
          <h3 className={classes.title}>{SHOPPING_COMMENT_TIMELINE}</h3>
          {commentList
            .sort((a: Todo, b: Todo) => {
              if (a.timestamp > b.timestamp) return -1;
              if (a.timestamp < b.timestamp) return 1;
              return 0;
            })
            .map((item: Todo) => {
              return (
                <ShoppingCommentTimelineItemContainer
                  comment={item}
                  key={item.commentId}
                  shoppingId={shoppingId}
                />
              );
            })}
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default ShoppingCommentTimeline;
